var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex } from '@chakra-ui/react';
import { rem } from 'polished';
import { ArrowForwardCircleIcon } from '../icons';
export const NavigationButtons = (_a) => {
    var { onAction, fillColor = '#1E1E1E', viewNext = true, viewBack = true } = _a, props = __rest(_a, ["onAction", "fillColor", "viewNext", "viewBack"]);
    // icon component
    const ArrowForward = ArrowForwardCircleIcon({ fillColor });
    return (_jsxs(Flex, Object.assign({ gap: 3 }, props, { children: [viewBack && (_jsx(Button, Object.assign({ "aria-label": "back-btn", w: "10", h: "10", sx: {
                    border: `${rem(1)} ${fillColor !== null && fillColor !== void 0 ? fillColor : 'black'} solid`,
                    borderRadius: '50%',
                    padding: rem(2),
                    lineHeight: rem(16),
                    _hover: {
                        borderWidth: rem(2),
                    },
                }, onClick: () => onAction('back') }, { children: _jsx(ArrowForward, { sx: {
                        transform: "scaleX(-1)"
                    } }) }))), viewNext && (_jsx(Button, Object.assign({ "aria-label": "next-btn", w: "10", h: "10", sx: {
                    border: `${rem(1)} ${fillColor !== null && fillColor !== void 0 ? fillColor : 'black'} solid`,
                    borderRadius: '50%',
                    padding: rem(2),
                    lineHeight: rem(16),
                    _hover: {
                        borderWidth: rem(2),
                    },
                }, onClick: () => onAction('next') }, { children: _jsx(ArrowForward, {}) })))] })));
};
//# sourceMappingURL=index.js.map